import { Route, Routes } from 'react-router-dom';
import FilePage from './pages/FilePage/FilePage';

const FileContainer = () => {
  return (
    <Routes>
      <Route path=":id" element={<FilePage />} />
    </Routes>
  );
};

export default FileContainer;
